import { render } from "./no-devices-notice.vue?vue&type=template&id=6536691c&scoped=true&ts=true"
import script from "./no-devices-notice.vue?vue&type=script&lang=ts"
export * from "./no-devices-notice.vue?vue&type=script&lang=ts"

import "./no-devices-notice.vue?vue&type=style&index=0&id=6536691c&scoped=true&lang=css"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6536691c"]])

export default __exports__